import { FeatureName, Program, ProgramStatus, User } from '@bybeam/platform-types';
import { checkProgramHasAnyFeature } from './checkFeature.js';

export const isProgramReferred = (program: Program, user: User): boolean =>
  program.status === ProgramStatus.ReferralOnly &&
  user.referrals?.some(({ program: referralProgram }) => referralProgram.id === program.id);

export const isProgramOpen = (program: Program, user: User): boolean =>
  program.status === ProgramStatus.Open || isProgramReferred(program, user);

export function hasApplicantType(program: Program, user: User): boolean {
  return program.applicantTypes?.some(
    ({ applicantType }) => applicantType.id === user.applicantProfile?.applicantType?.id,
  );
}

/**
 * ToDo: Temporary function to check if a program allows anonymous access. This will be removed once we decouple program query from partner query.
 * Ticket ENG-4880: https://linear.app/bybeam/issue/ENG-4880/decouple-program-fetching-from-partner-context-in-platform-ui
 */
export function canAnonymousAccessProgram(program: Program, user: User): boolean {
  return user.isAnonymous ? (program.allowAnonymousAccess ?? false) : true;
}

export function canAccessProgram(program: Program, user: User): boolean {
  return (
    isProgramOpen(program, user) &&
    hasApplicantType(program, user) &&
    canAnonymousAccessProgram(program, user)
  );
}

export function canCreateApplication(program: Program, user: User): boolean {
  return (
    ([ProgramStatus.Open, ProgramStatus.Closed].includes(program.status) ||
      isProgramReferred(program, user)) &&
    hasApplicantType(program, user)
  );
}

export function programHasPayments(program: Program): boolean {
  return checkProgramHasAnyFeature(program, [
    FeatureName.PaymentsClaimFunds,
    FeatureName.PaymentsExternalTracking,
    FeatureName.PaymentsPartnerIssued,
  ]);
}

export function programHasBeamPayments(program: Program): boolean {
  return checkProgramHasAnyFeature(program, [
    FeatureName.PaymentsClaimFunds,
    FeatureName.PaymentsPartnerIssued,
  ]);
}
